import { render } from "./PaymentRequest.vue?vue&type=template&id=71ab00fc"
import script from "./PaymentRequest.vue?vue&type=script&lang=js"
export * from "./PaymentRequest.vue?vue&type=script&lang=js"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__